import { SpeedChip, VehicleEquipmentIcons } from '@/components/controls';
import { getStatusColor, getStatusForeColor, getStatusLabel } from '@/utils';
import { useDallasKeys } from '@/utils/config';
import {
  DirectionsCar as DirectionsCarIcon,
  Key as KeyIcon,
  Nfc as NfcIcon,
  Router as RouterIcon,
} from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Box,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';

export function VehicleListItem({ item, feature, ...props }) {
  const primary =
    feature.properties.vehicle?.registrationNumber ?? feature.properties.imei;
  const secondary =
    feature.properties?.vehicle?.fleetNumber ?? 'Unassigned tracker';

  return (
    <ListItemButton
      {...props}
      dense
      disableGutters
      sx={
        item
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${item.size}px`,
              transform: `translateY(${item.start}px)`,
              px: 1,
            }
          : { px: 1 }
      }
    >
      <Box sx={{ pr: 1 }}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            feature.properties?.driver?.code ? (
              <Tooltip
                title={
                  feature.properties?.driver?.collarNumber ??
                  feature.properties?.driver?.code
                }
                placement="right"
              >
                <Avatar
                  sx={(theme) => ({
                    width: 22,
                    height: 22,
                    border: `2px solid ${theme.palette.background.paper}`,
                    bgcolor: theme.palette.text.primary,
                  })}
                />
              </Tooltip>
            ) : feature.properties?.rfidCard ? (
              <Tooltip
                title={
                  feature.properties?.rfidCard.label ??
                  feature.properties?.rfidCard.reference
                }
                placement="right"
              >
                <Avatar
                  sx={(theme) => ({
                    width: 22,
                    height: 22,
                    border: `2px solid ${theme.palette.background.paper}`,
                    bgcolor: theme.palette.text.primary,
                  })}
                >
                  {useDallasKeys ? (
                    <KeyIcon sx={{ fontSize: 12 }} />
                  ) : (
                    <NfcIcon sx={{ fontSize: 12 }} />
                  )}
                </Avatar>
              </Tooltip>
            ) : undefined
          }
        >
          <Tooltip
            title={getStatusLabel(feature.properties?.status)}
            placement="top"
          >
            <Avatar
              sx={{
                color: getStatusForeColor(feature.properties?.status),
                bgcolor: getStatusColor(feature.properties?.status),
                borderColor: getStatusForeColor(feature.properties?.status),
                borderWidth: 2,
                borderStyle: 'solid',
              }}
            >
              {feature.properties?.vehicle?.identificationNumber ? (
                <DirectionsCarIcon />
              ) : (
                <RouterIcon />
              )}
            </Avatar>
          </Tooltip>
        </Badge>
      </Box>
      <ListItemText
        primary={primary}
        secondary={secondary}
        slotProps={{
          root: { sx: { flexShrink: 0 } },
          primary: { noWrap: true },
          secondary: { noWrap: true },
        }}
      />
      <SpeedChip
        ignitionOn={feature.properties.ignitionOn}
        speedKilometresPerHour={feature.properties.speedKilometresPerHour}
        speedLimitKilometresPerHour={
          feature.properties.reverseGeocode?.speedLimitKilometresPerHour
        }
        // brokenRules={feature.properties?.brokenRules}
      />
      <VehicleEquipmentIcons properties={feature.properties} sx={{ pl: 0.5 }} />
    </ListItemButton>
  );
}
